import React from 'react';
import { Box, Typography } from '@mui/material';
import ScrollFadeWrapper from '../../ScrollFadeWrapper/ScrollFadeWrapper';
import { MedicalAidSeoDetailCard } from './SeoDetailMedicalAidModuleShared';

const SeoDetailMedicalAidModuleMobileComponent = ({ data }) => {
  if (!data) return null;

  const { title, description, footer, sections = [] } = data;

  return (
    <Box
      sx={{
        width: '100%',
        boxSizing: 'border-box',
        px: '16px',
      }}
    >
      <Box
        sx={{
          width: '100%',
          backgroundColor: '#E3E6E8',
          borderRadius: '32px',
          px: '16px',
          pt: '32px',
          pb: '64px',
          boxSizing: 'border-box',
        }}
      >
        <ScrollFadeWrapper variant="text">
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              gap: '12px',
              textAlign: 'center',
            }}
          >
            <Typography
              component="h2"
              sx={{
                fontFamily: 'Inter, sans-serif',
                fontWeight: 700,
                fontSize: '2rem',
                lineHeight: '2.25rem',
                letterSpacing: '-0.04em',
                color: '#162F3B',
                whiteSpace: 'pre-line',
              }}
            >
              {title}
            </Typography>

            <Typography
              component="p"
              sx={{
                fontFamily: 'Inter, sans-serif',
                fontWeight: 400,
                fontSize: '1rem',
                lineHeight: '1.5rem',
                letterSpacing: '-0.02em',
                color: '#162F3B',
                whiteSpace: 'pre-line',
                maxWidth: '600px',
              }}
            >
              {description}
            </Typography>
          </Box>
        </ScrollFadeWrapper>

        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: '20px',
            mt: '16px',
          }}
        >
          {sections.map((section, index) => (
            <ScrollFadeWrapper
              key={section.title || index}
              delay={index * 0.15}
            >
              <MedicalAidSeoDetailCard section={section} isDesktop={false} />
            </ScrollFadeWrapper>
          ))}
        </Box>

        {footer ? (
          <Typography
            sx={{
              textAlign: 'center',
              fontFamily: 'Inter, sans-serif',
              fontSize: '0.9375rem',
              fontWeight: 400,
              lineHeight: '1.375rem',
              letterSpacing: '-0.02em',
              color: '#162F3B',
              mt: '24px',
              maxWidth: '100%',
            }}
          >
            {footer}
          </Typography>
        ) : null}
      </Box>
    </Box>
  );
};

export default SeoDetailMedicalAidModuleMobileComponent;
